import { render, staticRenderFns } from "./LessonPage.vue?vue&type=template&id=582431c8&scoped=true&lang=true&"
import script from "./LessonPage.vue?vue&type=script&lang=js&"
export * from "./LessonPage.vue?vue&type=script&lang=js&"
import style0 from "./LessonPage.vue?vue&type=style&index=0&id=582431c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582431c8",
  null
  
)

export default component.exports